// extracted by mini-css-extract-plugin
export default {"container":"Home_container__SrM0+","itemContainer":"Home_itemContainer__7EQ01","title":"Home_title__Uzfzs","box":"Home_box__HGUb1"};